import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'promotional_events-pdp_promo_banner-click';
/**
 * Promo banner &quot;learn more&quot; on click in PDP
 */
export function trackPromotionalEventsPdpPromoBannerClick(customParameterToken) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { customParameterToken },
    });
}
